import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [
// 公司信息
{
  path: "/companyInfo/:invoiceInfoId?",
  name: "companyInfo",
  component: function component() {
    return import("../../../views/member/info/company_info.vue");
  },
  meta: {
    title: "公司信息",
    foot: true
  }
},
// 公司信息记录
{
  path: "/companyInfoRecord",
  name: "companyInfoRecord",
  component: function component() {
    return import("../../../views/member/info/company_info_record.vue");
  },
  meta: {
    title: "公司信息记录",
    foot: true
  }
},
// 红包池
{
  path: "/redPacketPool",
  name: "redPacketPool",
  component: function component() {
    return import("../../../views/member/redPacketPool/index.vue");
  },
  meta: {
    title: "红包池",
    foot: true
  }
}];